import {createSlice} from "@reduxjs/toolkit";

const initialAddAppFlyerTokenState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  exportData: [], 
  timeSlotlist: [],
  usersCount: null,
  allCompanyList: [], 
  newTimeSlot: {},
  timeSlotForEdit: {},
  itemGame: {},
  itemTokens: []
};

export const callTypes = {
    list: "list",
    action: "action"
};

export const AddTimeSlotSlice = createSlice({
    name: "addTimeSlote",
    initialState: initialAddAppFlyerTokenState,
    reducers: {
        catchError: (state, action) => {
            state.error = `${action.type}: ${action.payload.error}`;
            if (action.payload.callType === callTypes.list) {
              state.listLoading = false;
            } else {
              state.actionsLoading = false;
            }
        },
        startCall: (state, action) => {
            state.error = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            }
        },
        clearfetchStaffUsers: (state, action) => {
            state.listLoading = false;
            state.error = null;
            state.entities = [];
            state.totalCount = 0;
        },
        emptyList: (state, action) => {
            state.error = null;
            state.entities = [];
            // state.totalCount = 0;
            state.exportData = [];
        },
        timeSlotList: (state, action) => {
            const { totalCount, entities } = action.payload;
            state.listLoading = false;
            state.error = null;
            state.entities = entities;
            state.totalCount = totalCount;
        },
        companyList: (state, action) => {
            const { allCompanyList } = action.payload;
            state.listLoading = false;
            state.error = null;
            state.totalCount = 0;
            state.allCompanyList = allCompanyList;
        },
        createTimeSlotToken: (state, action) => {
            const { newTimeSlot } = action.payload;
            state.error = null;
            console.log("newTimeSlot",newTimeSlot);
            state.newTimeSlot = newTimeSlot;
        },
        singleItemFetched: (state, action) => {
            state.actionsLoading = false;
            state.timeSlotForEdit = action.payload.timeSlotForEdit;
            state.itemGame = action.payload.companyForEdit;
            state.error = null;
        },
    }
});      